import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {ibeaconApply, ibeacons, ibeaconsConfigure, ibeaconsAssign, userIbeacons, ibeaconsBatchConfigure} = api


/**
 * 查找
 */
export async function findUserIbeacons(params) {
    return request({url: userIbeacons, method: 'get', data: params,})
}

export async function findIbeacons(params) {
    return request({url: ibeacons, method: 'get', data: params,})
}

/**
 * 申请
 */
export async function applyIbeacon(params) {
    return request({url: ibeaconApply, method: 'post', data: params,})
}

/**
 * 发货
 */
export async function assignIbeacon(params) {
    return request({url: ibeaconsAssign, method: 'post', data: params,})
}

/**
 * 配置
 */
export async function configureIbeacon(params) {
    return request({url: ibeaconsConfigure, method: 'post', data: params,})
}

export async function batchConfigureIbeacon(params) {
    return request({url: ibeaconsBatchConfigure, method: 'post', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/ibeaconConfig.js